var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.740234H140V140.74H0V0.740234ZM107.024 118.107C100.532 118.107 96.8625 114.724 94.045 110.115L83.3525 116.328C87.2142 123.958 95.1067 129.779 107.328 129.779C119.823 129.779 129.127 123.293 129.127 111.445C129.127 100.461 122.815 95.5786 111.638 90.7777L108.348 89.3719C102.702 86.9219 100.258 85.3294 100.258 81.3802C100.258 78.1894 102.708 75.7452 106.558 75.7452C110.332 75.7452 112.764 77.3377 115.022 81.3802L125.265 74.8061C120.931 67.1819 114.923 64.2711 106.558 64.2711C94.8092 64.2711 87.29 71.7844 87.29 81.6544C87.29 92.3586 93.59 97.4277 103.087 101.47L106.377 102.882C112.379 105.507 115.955 107.105 115.955 111.614C115.955 115.383 112.473 118.107 107.024 118.107V118.107ZM56.0408 118.019C51.52 118.019 49.6358 114.928 47.5708 111.253L36.8608 117.739C39.9642 124.308 46.0658 129.756 56.595 129.756C68.2558 129.756 76.2417 123.555 76.2417 109.934V65.0177H63.0875V109.759C63.0875 116.334 60.3575 118.019 56.035 118.019H56.0408Z",
    fill: "#3E4348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.a17ee366b2a287d40bc05a9f132288ad.svg";
export { ForwardRef as ReactComponent };